import { withStatusOrder } from './utils';

export const OPTGL01 = {
    header: {
        en: 'Chat Initiated',
        hi: 'चैट शुरू हो गई है',
        kn: 'ಚಾಟ್ ಪ್ರಾರಂಭಿಸಲಾಗಿದೆ',
        ta: 'அரட்டையைத் தொடங்கியது',
        te: 'చాట్ ప్రారంభించబడింది',
    },
    label: {
        en: 'Enquiry Creation Pending',
        hi: 'पूछताछ निर्माण लंबित',
        kn: 'ವಿಚಾರಣೆಯ ರಚನೆ ಬಾಕಿಯಿದೆ',
        ta: 'விசாரணை உருவாக்கம் நிலுவையில் உள்ளது',
        te: 'విచారణ సృష్టి పెండింగ్‌లో ఉంది',
    },
    order: 1,
    color: 'info',
    description: {
        en: 'The customer has received the WhatsApp flow. Awaiting flow submission',
        hi: 'ग्राहक को व्हाट्सएप प्रवाह प्राप्त हुआ है। प्रवाह जमा होने की प्रतीक्षा है',
        kn: 'ಗ್ರಾಹಕನು ವಾಟ್ಸಾಪ್ ಫ್ಲೋವನ್ನು ಸ್ವೀಕರಿಸಿದ್ದಾನೆ. ಫ್ಲೋ ಸಲ್ಲಿಕೆಗೆ ಕಾಯುತ್ತಿದೆ',
        ta: 'வாடிக்கையாளர் வாட்ஸ்அப் அனுமதி பெற்றுள்ளார். அனுமதி சமர்ப்பிக்க காத்திருக்கிறது',
        te: 'కస్టమర్ WhatsApp ఫ్లోను స్వీకరించాడు. ఫ్లో సమర్పణ కోసం వేచి ఉంది',
    },
};

export const OPTGL02 = {
    header: {
        en: 'Enquiry Created',
        hi: 'पूछताछ बनाई गई है',
        kn: 'ವಿಚಾರಣೆ ರಚಿಸಲಾಗಿದೆ',
        ta: 'விசாரணை உருவாக்கப்பட்டது',
        te: 'విచారణ సృష్టించబడింది',
    },
    label: {
        en: 'Income Details Pending',
        hi: 'आय विवरण लंबित',
        kn: 'ಆದಾಯದ ವಿವರಗಳು ಬಾಕಿಯಿವೆ',
        ta: 'வருவாய் விவரங்கள் நிலுவையில் உள்ளன',
        te: 'ఆదాయం వివరాలు పెండింగ్‌లో ఉన్నాయి',
    },
    order: 2,
    color: 'info',
    description: {
        en: 'The customer has submitted the WhatsApp flow',
        hi: 'ग्राहक ने व्हाट्सएप प्रवाह जमा किया है',
        kn: 'ಗ್ರಾಹಕನು ವಾಟ್ಸಾಪ್ ಫ್ಲೋವನ್ನು ಸಲ್ಲಿಸಿದ್ದಾನೆ',
        ta: 'வாடிக்கையாளர் வாட்ஸ்அப் அனுமதியை சமர்ப்பித்துள்ளார்',
        te: 'కస్టమర్ WhatsApp ఫ్లోను సమర్పించాడు',
    },
};

export const OPTGL03 = {
    header: {
        en: 'Income Details',
        hi: 'आय विवरण',
        kn: 'ಆದಾಯದ ವಿವರಗಳು',
        ta: 'வருவாய் விவரங்கள்',
        te: 'ఆదాయం వివరాలు',
    },
    label: {
        en: 'Collateral Details Pending - Gold',
        hi: 'गोल्ड संपार्श्विक विवरण लंबित',
        kn: 'ಚಿನ್ನದ ಪಣದ ವಿವರಗಳು ಬಾಕಿಯಿವೆ',
        ta: 'தங்க பிணை விவரங்கள் நிலுவையில் உள்ளன',
        te: 'గోల్డ్ కోలాటరల్ వివరాలు పెండింగ్‌లో ఉన్నాయి',
    },
    order: 3,
    color: 'info',
    description: {
        en: 'The customer has filled the income and expense details',
        hi: 'ग्राहक ने आय और व्यय विवरण भरा है',
        kn: 'ಗ್ರಾಹಕನು ಆದಾಯ ಮತ್ತು ವೆಚ್ಚದ ವಿವರಗಳನ್ನು ಭರ್ತಿಮಾಡಿದ್ದಾನೆ',
        ta: 'வாடிக்கையாளர் வருவாய் மற்றும் செலவின் விவரங்களை நிரப்பியுள்ளார்',
        te: 'కస్టమర్ ఆదాయం మరియు ఖర్చుల వివరాలు పూరించాడు',
    },
};

export const OPTGL04 = {
    header: {
        en: 'Collateral Details - Gold Asset',
        hi: 'संपार्श्विक विवरण - स्वर्ण संपत्ति',
        kn: 'ಪಣದ ವಿವರಗಳು - ಚಿನ್ನದ ಆಸ್ತಿಗಳು',
        ta: 'பிணை விவரங்கள் - தங்க சொத்து',
        te: 'పణ వివరాలు - గోల్డ్ ఆస్తి',
    },
    label: {
        en: 'Aadhaar Verification Pending',
        hi: 'आधार सत्यापन लंबित',
        kn: 'ಆಧಾರ್ ಪರಿಶೀಲನೆ ಬಾಕಿಯಿದೆ',
        ta: 'ஆதார் சரிபார்ப்பு நிலுவையில் உள்ளது',
        te: 'ఆధార్ ధృవీకరణ పెండింగ్‌లో ఉంది',
    },
    order: 4,
    color: 'info',
    description: {
        en: 'The customer has filled the collateral property details',
        hi: 'ग्राहक ने संपार्श्विक संपत्ति विवरण भरा है',
        kn: 'ಗ್ರಾಹಕನು ಪಣದ ಆಸ್ತಿ ವಿವರಗಳನ್ನು ಭರ್ತಿಮಾಡಿದ್ದಾನೆ',
        ta: 'வாடிக்கையாளர் பிணை சொத்து விவரங்களை நிரப்பியுள்ளார்',
        te: 'కస్టమర్ పణ ఆస్తి వివరాలు పూరించాడు',
    },
};

export const OPTGL05 = {
    header: {
        en: 'Aadhaar Verified',
        hi: 'आधार सत्यापित',
        kn: 'ಆಧಾರ್ ಪರಿಶೀಲನೆ ಮಾಡಲಾಗಿದೆ',
        ta: 'ஆதார் சரிபார்க்கப்பட்டது',
        te: 'ఆధార్ ధృవీకరించబడింది',
    },
    label: {
        en: 'PAN Verification Pending',
        hi: 'पैन सत्यापन लंबित',
        kn: 'ಪ್ಯಾನ್ ಪರಿಶೀಲನೆ ಬಾಕಿಯಿದೆ',
        ta: 'பான் சரிபார்ப்பு நிலுவையில் உள்ளது',
        te: 'పాన్ ధృవీకరణ పెండింగ్‌లో ఉంది',
    },
    order: 5,
    color: 'info',
    description: {
        en: 'The customer has verified their Aadhaar',
        hi: 'ग्राहक ने अपना आधार सत्यापित कर लिया है',
        kn: 'ಗ್ರಾಹಕನು ತನ್ನ ಆಧಾರ್ ಪರಿಶೀಲಿಸಿದ್ದಾನೆ',
        ta: 'வாடிக்கையாளர் தனது ஆதாரைச் சரிபார்த்தார்',
        te: 'కస్టమర్ తన ఆధార్‌ను ధృవీకరించాడు',
    },
};

export const OPTGL06 = {
    header: {
        en: 'PAN Verified',
        hi: 'पैन सत्यापित',
        kn: 'ಪ್ಯಾನ್ ಪರಿಶೀಲನೆ ಮಾಡಲಾಗಿದೆ',
        ta: 'பான் சரிபார்க்கப்பட்டது',
        te: 'పాన్ ధృవీకరించబడింది',
    },
    label: {
        en: 'Application Submitted',
        hi: 'आवेदन प्रस्तुत किया गया',
        kn: 'ಅರ್ಜಿಯನ್ನು ಸಲ್ಲಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் சமர்ப்பிக்கப்பட்டது',
        te: 'అప్లికేషన్ సమర్పించబడింది',
    },
    order: 6,
    color: 'info',
    description: {
        en: 'The customer has verified their PAN',
        hi: 'ग्राहक ने अपना पैन सत्यापित कर लिया है',
        kn: 'ಗ್ರಾಹಕನು ತನ್ನ ಪ್ಯಾನ್ ಪರಿಶೀಲಿಸಿದ್ದಾನೆ',
        ta: 'வாடிக்கையாளர் தனது பானைச் சரிபார்த்தார்',
        te: 'కస్టమర్ తన పాన్‌ను ధృవీకరించాడు',
    },
};

export const OPTGL07 = {
    header: {
        en: 'Application Submitted',
        hi: 'आवेदन प्रस्तुत किया गया',
        kn: 'ಅರ್ಜಿಯನ್ನು ಸಲ್ಲಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் சமர்ப்பிக்கப்பட்டது',
        te: 'అప్లికేషన్ సమర్పించబడింది',
    },
    label: {
        en: 'Awaiting Decision',
        hi: 'निर्णय की प्रतीक्षा',
        kn: 'ನಿರ್ಧಾರದ ನಿರೀಕ್ಷೆ',
        ta: 'தீர்மானத்தை எதிர்பார்க்கிறது',
        te: 'తీర్మానం కోసం వేచి ఉంది',
    },
    order: 7,
    color: 'success',
    description: {
        en: 'The customer has submitted their application',
        hi: 'ग्राहक ने आवेदन प्रस्तुत किया है',
        kn: 'ಗ್ರಾಹಕನು ಅರ್ಜಿಯನ್ನು ಸಲ್ಲಿಸಿದ್ದಾನೆ',
        ta: 'வாடிக்கையாளர் விண்ணப்பத்தைச் சமர்ப்பித்தார்',
        te: 'కస్టమర్ తన అప్లికేషన్‌ను సమర్పించాడు',
    },
};

export const OPTGL08 = {
    header: {
        en: 'Application Approved',
        hi: 'आवेदन स्वीकृत',
        kn: 'ಅರ್ಜಿಯು ಅಂಗೀಕರಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் ஒப்புதலிடப்பட்டது',
        te: 'అప్లికేషన్ ఆమోదించబడింది',
    },
    label: {
        en: 'Awaiting Confirmation',
        hi: 'पुष्टि का इंतजार',
        kn: 'ದೃಢೀಕರಣ ನಿರೀಕ್ಷೆಯಲ್ಲಿ',
        ta: 'உறுதிப்படுத்தல் காத்திருக்கிறது',
        te: 'నిర్ధారణ కోసం వేచి ఉంది',
    },
    order: 8,
    color: 'success',
    description: {
        en: 'The loan application has been approved',
        hi: 'ऋण आवेदन स्वीकृत हो गया है',
        kn: 'ಸಾಲದ ಅರ್ಜಿಯು ಅಂಗೀಕರಿಸಲಾಗಿದೆ',
        ta: 'கடன் விண்ணப்பம் ஒப்புதலிடப்பட்டது',
        te: 'లోన్ అప్లికేషన్ ఆమోదించబడింది',
    },
};

export const OPTGL09 = {
    header: {
        en: 'Application Rejected',
        hi: 'आवेदन अस्वीकृत',
        kn: 'ಅರ್ಜಿಯನ್ನು ತಿರಸ್ಕರಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் நிராகரிக்கப்பட்டது',
        te: 'అప్లికేషన్ తిరస్కరించబడింది',
    },
    label: {
        en: 'Application Rejected',
        hi: 'आवेदन अस्वीकृत',
        kn: 'ಅರ್ಜಿಯನ್ನು ತಿರಸ್ಕರಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் நிராகரிக்கப்பட்டது',
        te: 'అప్లికేషన్ తిరస్కరించబడింది',
    },
    order: 9,
    color: 'error',
    description: {
        en: 'The loan application has been rejected',
        hi: 'ऋण आवेदन अस्वीकृत कर दिया गया है',
        kn: 'ಸಾಲದ ಅರ್ಜಿಯನ್ನು ತಿರಸ್ಕರಿಸಲಾಗಿದೆ',
        ta: 'கடன் விண்ணப்பம் நிராகரிக்கப்பட்டது',
        te: 'రుణం అప్లికేషన్ తిరస్కరించబడింది',
    },
};

export const SGLActiveCases = withStatusOrder({
    OPTGL01,
    OPTGL02,
    OPTGL03,
    OPTGL04,
    OPTGL05,
    OPTGL06,
});

export const SGLContinueJourneyCases = withStatusOrder({
    OPTGL02,
    OPTGL03,
    OPTGL04,
    OPTGL05,
    OPTGL06,
});

export const SGLSanction = withStatusOrder({
    OPTGL07,
});

export const SGLRejected = withStatusOrder({
    OPTGL01,
    OPTGL02,
    OPTGL03,
    OPTGL04,
    OPTGL05,
    OPTGL06,
    // OPTGL09,
});

export const SGLCancelled = withStatusOrder({
    OPTGL01,
    OPTGL02,
    OPTGL03,
    OPTGL04,
    OPTGL05,
    OPTGL06,
    OPTGL07,
})

const OPTGL02_Unserviceable = {
    ...OPTGL02,
    header: {
        ...OPTGL02.header,
        en: 'Unserviceable',
    }
}

export const SGLUnserviceable = withStatusOrder({
    OPTGL02: OPTGL02_Unserviceable,
})

export const getSGLAll = (currentStatusCode) => {
    let SGLAll = {
        OPTGL01,
        OPTGL02,
        OPTGL03,
        OPTGL04,
        OPTGL05,
        OPTGL06,
        OPTGL07,
    };

    if (currentStatusCode === 'OPTGL08') {
        SGLAll = {
            ...SGLAll,
            OPTGL08,
        }
    } else if (currentStatusCode === 'OPTGL09') {
        SGLAll = {
            ...SGLAll,
            OPTGL09,
        }
    } else {
        SGLAll = {
            ...SGLAll,
            OPTGLXX: {
                header: {
                    en: 'Awaiting Decision',
                    hi: 'फैसले का इंतजार',
                    kn: 'ತೀರ್ಮಾನಕ್ಕಾಗಿ ಕಾಯಲಾಗುತ್ತಿದೆ',
                    ta: 'முடிவிற்காக காத்திருக்கிறது',
                    te: 'నిర్ణయం కోసం వేచి ఉంది',
                },
                color: 'success',
            },
        }
    }

    return withStatusOrder(SGLAll);
};
